import styles from './loader.module.scss';

export function Loader() {
  return (
    <div className={styles['loader-holder']}>
      <div className={styles['load-spinner']}></div>
    </div>
  );
}
